module.exports = require('@makeswift/next-plugin')
